import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const foursatAPI = {
    // Configuración
    getConfig: () => api.get('/api/integraciones/4sat/config'),
    saveConfig: (data) => api.post('/api/integraciones/4sat/config', data),
    deleteConfig: () => api.delete('/api/integraciones/4sat/config'),
    testConnection: () => api.post('/api/integraciones/4sat/test'),
    
    // Dispositivos
    getDevices: () => api.get('/api/integraciones/4sat/devices'),
    
    // Sincronización
    syncImport: () => api.post('/api/integraciones/4sat/sync/import'),
    syncExportSingle: (vehiculoId) => api.post(`/api/integraciones/4sat/sync/export/${vehiculoId}`),
    syncExportAll: () => api.post('/api/integraciones/4sat/sync/export-all'),
    syncFull: () => api.post('/api/integraciones/4sat/sync/full'),
    getSyncStatus: () => api.get('/api/integraciones/4sat/sync/status'),
    
    // Captura Excel (nuevo flujo con background)
    iniciarCaptura: () => api.post('/api/integraciones/4sat/captura-excel/iniciar'),
    estadoCaptura: (capturaId) => api.get(`/api/integraciones/4sat/captura-excel/estado/${capturaId}`),
    descargarCaptura: (capturaId) => api.get(`/api/integraciones/4sat/captura-excel/descargar/${capturaId}`, { responseType: 'blob' }),
    
    // Importación inteligente
    iniciarImportacion: () => api.post('/api/integraciones/4sat/importacion-inteligente/iniciar'),
    estadoImportacion: (importId) => api.get(`/api/integraciones/4sat/importacion-inteligente/estado/${importId}`),
};

export default foursatAPI;
